import {
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  makeStyles,
  Typography
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import React from "react";
import { useIntl } from "react-intl";
import { updateImage } from "../ducks/actions";
import { useActionRequest } from "../hooks";
import FileUploader from "./FileUploader";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(3)
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }
}));

const EditImageDialog = ({ parentId, parentType, imageType, imageUrl, onClose }) => {
  const classes = useStyles();
  const intl = useIntl();

  const updateImageRequest = useActionRequest({
    action: updateImage
  });

  const onUpdateImage = ({ file: image }) => {
    updateImageRequest({ parentId, parentType, imageType, image });
  };

  return (
    <Dialog open={Boolean(parentId)} onClose={onClose} maxWidth="sm" fullWidth>
      <div className={classes.title}>
        <Typography variant="h5">
          {intl.formatMessage({
            defaultMessage: "Edit Image",
            id: "Shared.EditImageDialog.EditImage"
          })}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent className={classes.container}>
        <FileUploader
          onFileUpload={onUpdateImage}
          imageAlt={imageType}
          imageUrl={imageUrl}
          accept="image/*"
        />
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
};

export default EditImageDialog;
